// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__V41da","colCheckbox":"styles_colCheckbox__1ilT_"};